import Inputmask from "inputmask";
import {onReady} from "../functions";

class VGInputMask {
	init() {
		let _this = this,
			$selector = document.querySelectorAll('[data-mask]');

		if ($selector.length) {
			for (let i = 1; i <= $selector.length; i++) {
				let masked = $selector[i - 1].dataset.mask,
					format, opts = {};

				switch (masked) {
					case 'phone':
						format = $selector[i - 1].dataset.format || '8 (999) 999-99-99';
						opts = Object.assign({
							clearIncomplete: true,
							showMaskOnHover: true,
							onBeforeMask: function (pastedValue, opts) {
								return _this.normalize_phone(pastedValue)
							},
						}, opts);
						break;
				}

				if (format) {
					let im = new Inputmask(format, opts);
					im.mask($selector[i - 1]);
				}
			}
		}
	}

	normalize_phone(val) {
		return val.replace(new RegExp(/\D/, 'g'), '').split('').reverse().slice(0, 10).reverse().join('');
	}
}
function enableInputmask() {
	new VGInputMask().init();
}

onReady(enableInputmask)
